module.exports = __webpack_public_path__ + "img/CY120016.2c9b60a0.png";